import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { GetJobResponse } from './types';

export function getJob({
  jobId,
  corporation_id,
}: {
  jobId: string;
  corporation_id: number;
}) {
  const { data, error, isLoading, mutate } = useSWR<{
    data: GetJobResponse;
  }>(
    jobId
      ? `new-sales-tax/jobs/${jobId}?corporation_id=${corporation_id}`
      : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    job: data?.data,
    isLoading,
    error,
    mutate,
  };
}
